var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-field',{staticClass:"display-datepicker",attrs:{"label":_vm.label,"message":_vm.message}},[_c('b-datepicker',{attrs:{"icon":"calendar-today","date-formatter":_setup.formatDateWithTime,"value":_vm.value,"name":_vm.name,"disabled":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }